import React, { Component, Fragment } from 'react';
import { PATHS, DETAIL_ACTIONS, FEATURE_FLAGS } from "../../../../../constants/Define";
import * as HMS from "../../../common/component/Index";
import * as Func from '../../../../../helpers/functions';
import TranslateButton from '../../../common/component/TranslateButton';
import { isEqual, get, cloneDeep, find } from 'lodash';
import Wrapper from './../../../common/component/Wrapper';
import Input from "../../../common/component/Input";
import { checkUndefine } from "../../../../../helpers/functions";
import Airport from '../../../../../models/Airport';
import { Button, Checkbox, Radio } from 'antd';
import ToAirportListModal from './ToAirportListModal';
import './style.less';

const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    validation: {},
    isGetItem: false
};

class AirportDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            id: null,
            isSubmit: false,
            airport: this.props.airportState.detail.airport,
            toAirportList: this.props.airportState.toAirportList,
            selectedAirportCodes: [],
        }
    }

    componentDidMount() {
        this.initDetail()
    }
    

    initDetail() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({id: id, action: DETAIL_ACTIONS.UPDATE });
            this.props.getAirportDetail(id);
            this.props.getToAirportList(id);
        }else{
            this.props.getToAirportList("undefined");
        }
    }

    componentWillUnmount() {
        this.props.setAirportDetail(new Airport())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.airportState.detail.airport && !isEqual(nextProps.airportState.detail.airport, this.props.airportState.detail.airport)) {
            this.setState({ airport: nextProps.airportState.detail.airport, action: nextProps.airportState.detail.airport.id ? 'UPDATE' : this.state.action });
        }

        if (nextProps.airportState.toAirportList && !isEqual(nextProps.airportState.toAirportList, this.props.airportState.toAirportList)) {
            const toAirportList = nextProps.airportState.toAirportList || [];
            const selectedAirportCodes = toAirportList.filter(x=>x.isReferenceSegment).map(x=>x.airportCode);
            this.setState({ toAirportList:  toAirportList, selectedAirportCodes: selectedAirportCodes});
        }
    }

    inputText = (key, requiredInput = false, requireTranslate = true, col = 6) => {
        const { t } =  this.props;
        const { validation, airport } = this.state;
        return (
            <HMS.FormWrapperInputComponent
                className={`col-md-${col}`}
                isRequired={requiredInput}
                isValidation={requiredInput}
                dataValidation={airport[key]}
                validation={validation[key]}
                labelTitle={t(`item.airport.${key}`)}
                visible={requireTranslate}
            >
                <Input placeholder="" type={`text`}
                    className={`form-control`}
                    name={key} onChange={(e) => this.onChange(key, e.target.value)}
                    value={checkUndefine(airport[key])} />
            </HMS.FormWrapperInputComponent>
        )
    }

    updateToAirportList = (airportCodes) => {
        this.setState({ selectedAirportCodes: airportCodes});
    }

    render() {
        const { t } =  this.props;
        const { action, isSubmit, validation, isGetItem, airport, toAirportList, selectedAirportCodes } = this.state;

        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent className="airport-detail-page fix-pd-wrapper-form">
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'airports'}
                            titleHeader={
                                action === "CREATE" ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.airport.title')}`).toLowerCase())
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.airport.title')}`.toLowerCase()))
                            }
                            componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                                <TranslateButton
                                    languages={airport.translations}
                                    current={airport.languageCode}
                                    validation={validation.languageCode}
                                    onChange={this.onShowTranslate}
                                    onClear={this.onExitTranslate}
                                    defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                    onSelectDefault={language => this.onChange('languageCode', language.code)}
                                    onRemove={this.onRemoveTranslate} />
                            }
                        />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={isGetItem}
                            onClickBack={this.onClickBack}
                            backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                            titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                            onChangeActive={e => this.onChangeDetail(e.name, e.value)}
                            submitButtonRight={true}
                            statusActiveName={`isActive`}
                        >
                            <Wrapper className='col-md-12 basic-section'>
                                <HMS.FormWrapperItem>
                                    {this.inputText('id', true, action === DETAIL_ACTIONS.CREATE, 3)}
                                    {this.inputText('ICAO', true, action !== DETAIL_ACTIONS.TRANSLATE, 3)} 
                                    {this.inputText('name', true)}
                                    {this.inputText('cityId', true, action !== DETAIL_ACTIONS.TRANSLATE)} 
                                    {this.inputText('cityName', true)}
                                    {this.inputText('countryId', true, action !== DETAIL_ACTIONS.TRANSLATE)}
                                    {this.inputText('countryName')}
                                    {this.inputText('order', false, action !== DETAIL_ACTIONS.TRANSLATE)}
                                    {this.inputText('provinceName')}

                                    <HMS.FormWrapperInputComponent
                                        className="col-md-6"
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={airport["airportDisplayType"]}
                                        validation={validation["airportDisplayType"]}
                                        labelTitle={t(`item.airport.isDisplay`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <Radio.Group
                                            className="d-flex flex-column"
                                            value={airport.isDisplay}
                                            onChange={(e) => this.onChange("isDisplay", e.target.value) & this.onChange("airportDisplayType", [])}
                                        >
                                            <Radio value={false}>
                                                {t(`item.airport.hide`)}
                                            </Radio>
                                            <Radio className='mt-2' value={true}>
                                                {t(`item.airport.show`)}
                                                {airport.isDisplay ? (
                                                    <Checkbox.Group
                                                        className='d-flex flex-column mt-2'
                                                        value={airport.airportDisplayType}
                                                        onChange={(e) => this.onChange("airportDisplayType", e)}
                                                    >
                                                        <Checkbox value={1} className='ml-4'>{t(`item.airport.departureAirport`)}</Checkbox>
                                                        <Checkbox value={2} className='ml-4 mt-1'>{t(`item.airport.returnAirport`)}</Checkbox>
                                                    </Checkbox.Group>
                                                ) : null}
                                            </Radio>
                                        </Radio.Group>
                                    </HMS.FormWrapperInputComponent>

                                    <div className="col-md-6">
                                        <ToAirportListModal t={t} action={action} toAirportList={toAirportList} selectedAirportCodes={selectedAirportCodes} updateToAirportList={this.updateToAirportList} />
                                    </div>
                                </HMS.FormWrapperItem>
                            </Wrapper>
                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        )
    }

    onSaveTranslate = () => {
        const { airport } = this.state;
        const translateFunction = airport.translate.id ? this.props.updateAirportTranslate : this.props.createAirportTranslate;
        translateFunction(airport, airport.languageCode);
        this.onExitTranslate();
    }

    onChange = (fieldName, value) => {
        const airport = this.state.airport;
        const keyString = fieldName === 'key' ? this.convertStringKey(value) : value;
        airport[fieldName] = (typeof keyString === "string" ? keyString.trimLeft() : keyString);
        this.setState({ airport });
    };

    onSubmit = (e) => {
        e.preventDefault();
        const { airport, selectedAirportCodes, action } = this.state;
        if (this.validate()) {
            if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
                this.onSaveTranslate()
            } else if (action === DETAIL_ACTIONS.CREATE) {
                this.props.createAirportDetail({ airport, selectedAirportCodes})
            } else {
                this.props.updateAirportDetail({ airport, selectedAirportCodes, props: this.props })
            }
        }
    }

    convertStringKey = (value) => {
        const convertedString = Func.vietnameseStringToUnicode(value)
        return convertedString
    }

    validate() {
        const { t } = this.props;
        let validate = {
            maxLength: { 
                id: Func.formatValidation(t('validation.statusCode.code.9'), 3) 
            },
            required: {
                id: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.airport.id`)),
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.airport.name`)),
                cityId: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.airport.cityId`)),
                cityName: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.airport.cityName`)),
                countryId: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.airport.countryId`)),
                ICAO: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.airport.ICAO`)),
            },
            minLength: {}
        };

        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }

        let valueValidate = {
            minLength: {}
        };

        if (this.state.airport.isDisplay) {
            validate.minLength["airportDisplayType"] = Func.formatValidation(t('validation.statusCode.code.1'), t("item.airport.isDisplay"));
            valueValidate.minLength["airportDisplayType"] = 1;
        }

        const result = Func.multipleValidate(this.state.airport, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.AIRPORT.LIST.path);
        }
    }

    onShowTranslate = (language) => {
        const { airport } = this.state;
        airport.setTranslate(language.code);
        airport.setData();
        this.setState({ airport, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const airport = cloneDeep(this.state.airport);
        const action = DETAIL_ACTIONS[airport.id ? 'UPDATE' : 'CREATE'];
        airport.setTranslate(undefined, true);
        airport.setData();
        this.setState({ airport, action });
    }

    onSaveTranslate = () => {
        const { airport } = this.state;
        const translateFunction = airport.translate.id ? this.props.updateAirportTranslate : this.props.createAirportTranslate;
        translateFunction(airport, airport.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { airport } = this.state;
        airport.setTranslate(language.code);
        this.props.deleteAirportTranslate(airport, { id: airport.id });
    }
}

export default AirportDetail;
